module.exports = __webpack_public_path__ + "img/ElectricalServicesOutlined.5f8ce4dd.svg";